import { Component, OnInit, ɵConsole } from '@angular/core';
import { Settings, AppSettings } from '../../app.settings';
import { AppService } from '../../app.service';
import { Property, Pagination } from '../../app.models';

import { Subscription } from 'rxjs';
import { MediaChange, MediaObserver } from '@angular/flex-layout'; 
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import {CfCarousel,CfHome,CfCardsHome } from '../../modelos/config/config'
import {ConfigService} from '../../servicios/config/config.service'
import { asLiteral } from '@angular/compiler/src/render3/view/util';
import { error } from 'console';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {

  home: CfHome;
  public slides :CfCarousel[] = [];
  public properties: CfCardsHome[]=[];  

  watcher: Subscription;
  activeMediaQuery = ''; 


  public viewType: string = 'grid';
  public viewCol: number = 25;
  public count: number = 8;
  public sort: string;
  public searchFields: any;
  public removedSearchField: string;
  public pagination:Pagination = new Pagination(1, 8, null, 2, 0, 0); 
  public message:string;
  // public featuredProperties: CfCardsHome[];

  public settings: Settings;
  constructor(
    private configService : ConfigService,
    public appSettings:AppSettings, 
    public appService:AppService, 
    public mediaObserver: MediaObserver)

    {

    //recuperamos configuración de home
    this.configService.getHome$().subscribe(
     { next : (data) => {
        if (data && data.length>0)
        {
          //Solo existirá siempre un solo registro en la tabla de cofiguración cf_home
          this.home=data[0]

          this.viewType = this.home.viewType;
          this.viewCol = this.home.viewCol; 
        }
      },

      error : (err) => {
        //El mensaje main se muestra en interceptor
        console.log(err)}
    }

    )

    this.settings = this.appSettings.settings;

    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {      
      if(change.mqAlias == 'xs') {
        this.viewCol = 100;
      }
      else if(change.mqAlias == 'sm'){
        this.viewCol = 50;
      }
      else if(change.mqAlias == 'md'){
        this.viewCol = 33.3;
      }
      else{
        this.viewCol = 25;
      }
    });

  }

  ngOnInit() {  
    this.getSlides();
    this.getProperties(); 
    // if (this.mediaObserver.isActive('xs')) {
    //    console.log('mobile version -XS')
    // }
    // this.getFeaturedProperties();
  }

  ngDoCheck(){
    return
    if(this.settings.loadMore.load){     
      this.settings.loadMore.load = false;     
      this.getProperties();  
    }
  }

  ngOnDestroy(){
    this.resetLoadMore();
    this.watcher.unsubscribe();
  }

  public getSlides(){

    this.configService.getcarousel$().subscribe(
      (data)=> {
        this.slides=data;
        console.log(data)
      }
    )


  }

  public getProperties(){


    this.configService.getCardshome$().subscribe(
      (data)=>{
        //Obtenemos el contenido
        this.properties=data
      },
      (erro)=>{
        //El error main, se gestiona en los interceptores
        alert('SUCEDIÓ UN ERROR INESPERADO.')
      },

      ()=>{
        //Complete, recuperamos las imágenes por cada contenido       

        this.properties.forEach( ( card,index)=>{          

          this.configService.getImagesCardsHome$(card.idCardsHome).subscribe(
            (images)=>{

              this.properties[index].gallery = images;

            }
          ),
          (error)=>{
            alert("Error")
          }
        }
        
        )


      }
      
    )

    return
    this.appService.getProperties().subscribe(data => {

      if(this.properties && this.properties.length > 0){  
        this.settings.loadMore.page++;
        this.pagination.page = this.settings.loadMore.page; 
      }

      let result = this.filterData(data);

      if(result.data.length == 0){
        this.properties.length = 0;
        this.pagination = new Pagination(1, this.count, null, 2, 0, 0);  
        this.message = 'No Results Found';
        return false;
      } 

      if(this.properties && this.properties.length > 0){  
        this.properties = this.properties.concat(result.data);          
      }
      else{
        this.properties = result.data;  
      }

      this.pagination = result.pagination;
      this.message = null;

      if(this.properties.length == this.pagination.total){
        this.settings.loadMore.complete = true;
        this.settings.loadMore.result = this.properties.length;
      }
      else{
        this.settings.loadMore.complete = false;
      }
    })
  }

  public resetLoadMore(){
    this.settings.loadMore.complete = false;
    this.settings.loadMore.start = false;
    this.settings.loadMore.page = 1;
    this.pagination = new Pagination(1, this.count, null, null, this.pagination.total, this.pagination.totalPages);
  }

  public filterData(data){
    return this.appService.filterData(data, this.searchFields, this.sort, this.pagination.page, this.pagination.perPage);
  }

  public searchClicked(){ 
    this.properties.length = 0;
    this.getProperties(); 
  }

  public searchChanged(event){
    event.valueChanges.subscribe(() => {
      this.resetLoadMore();
      this.searchFields = event.value;
      setTimeout(() => {      
        this.removedSearchField = null;
      });
      if(!this.settings.searchOnBtnClick){     
        this.properties.length = 0;  
      }            
    }); 

    event.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe(() => { 
      if(!this.settings.searchOnBtnClick){     
        this.getProperties(); 
      }
    });       
  } 
  public removeSearchField(field){ 
    this.message = null;   
    this.removedSearchField = field; 
  } 
 


  public changeCount(count){
    this.count = count;
    this.resetLoadMore();   
    this.properties.length = 0;
    this.getProperties();

  }
  public changeSorting(sort){    
    this.sort = sort;
    this.resetLoadMore(); 
    this.properties.length = 0;
    this.getProperties();
  }

  public changeViewType(obj){

    console.log(obj)

    this.viewType = obj.viewType;
    this.viewCol = obj.viewCol; 
  }


  // public getFeaturedProperties(){
  //   this.appService.getFeaturedProperties().subscribe(properties=>{
  //     this.featuredProperties = properties;
  //   })
  // } 

}
